import { Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

import { passwordsMatchValidator } from './password-validators';

/**
 * Cross-field validator directive for password match
 */
@Directive({
  selector: '[appPasswordsMatch]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PasswordsMatchValidatorDirective),
      multi: true,
    },
  ],
})
export class PasswordsMatchValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return passwordsMatchValidator(control);
  }
}
